"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQueryStringDate = exports.formatDateForQueryString = exports.formatDateForChip = exports.FILTER_DATE_RANGE_REGEX = void 0;
var _components = require("../components");
var FILTER_DATE_RANGE_REGEX = exports.FILTER_DATE_RANGE_REGEX = /^[0-9]{2}-[0-9]{2}-[0-9]{4}\|[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
var parseQueryStringDate = exports.parseQueryStringDate = function parseQueryStringDate(value) {
  if (!value || typeof value !== 'string') return undefined;
  var segments = value.split('|');
  if (segments.length !== 2) {
    return undefined;
  }
  var startDate = (0, _components.parseDate)(segments[0], _components.DEFAULT_DATE_FORMAT);
  var endDate = (0, _components.parseDate)(segments[1], _components.DEFAULT_DATE_FORMAT);
  if (!startDate || !endDate) {
    return undefined;
  }
  return {
    endDate: endDate,
    startDate: startDate
  };
};
var formatDateForChip = exports.formatDateForChip = function formatDateForChip(locale, startDate, endDate) {
  return "".concat((0, _components.formatDate)({
    date: startDate,
    pattern: _components.PICKER_DATE_FORMAT,
    locale: locale
  }), " - ").concat((0, _components.formatDate)({
    date: endDate,
    pattern: _components.PICKER_DATE_FORMAT,
    locale: locale
  }));
};
var formatDateForQueryString = exports.formatDateForQueryString = function formatDateForQueryString(locale, value) {
  var from = (0, _components.formatDate)({
    date: value.startDate,
    pattern: _components.DEFAULT_DATE_FORMAT,
    locale: locale
  });
  var to = (0, _components.formatDate)({
    date: value.endDate,
    pattern: _components.DEFAULT_DATE_FORMAT,
    locale: locale
  });
  return "".concat(from, "|").concat(to);
};